module.exports = __webpack_public_path__ + "9e609429.svg";